import { render, staticRenderFns } from "./FormInputFormat.vue?vue&type=template&id=1cb70c2c&scoped=true"
import script from "./FormInputFormat.vue?vue&type=script&lang=js"
export * from "./FormInputFormat.vue?vue&type=script&lang=js"
import style0 from "./FormInputFormat.vue?vue&type=style&index=0&id=1cb70c2c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cb70c2c",
  null
  
)

export default component.exports